import { ForwardRefExoticComponent, RefAttributes } from 'react';

import { Icon, IconAddressBook, IconProps } from '@tabler/icons-react';

/**
 * Special link placeholders:
 * :userId
 * :medicalOrganizationId
 * :medicalDoctorId
 */

export const linksData: {
  type: 'link';
  label: string;
  icon: ForwardRefExoticComponent<Omit<IconProps, 'ref'> & RefAttributes<Icon>>;
  link: string;
}[] = [
  {
    type: 'link',
    label: 'Contatti',
    icon: IconAddressBook,
    link: '/',
  },
];
